import { Td } from "@chakra-ui/react";

export const CableSubscriptionTableHead = () => {
  return (
    <>
      <Td>Package</Td>
      <Td>Price</Td>
      <Td>Company Price</Td>
      <Td>Status</Td>
      <Td>Action</Td>
    </>
  );
};

export const AirtimeSubscriptionTableHead = () => {
  return (
    <>
      <Td> Provider</Td>
      <Td> Plan Amount</Td>
      <Td> Plan-ID</Td>
      <Td>Network-ID</Td>
      <Td>Company-Amount</Td>
      <Td>Name</Td>
    </>
  );
};

export const DataSubscriptionTableHead = () => {
  return (
    <>
      <Td> Name</Td>
      <Td> Plan Amount</Td>
      {/* <Td> Plan-ID</Td>
      <Td>Network-ID</Td> */}
      <Td>Company-Amount</Td>
      <Td>Total</Td>
    </>
  );
};

export const LightSubscriptionTableHead = () => {
  return (
    <>
      <Td>Disco Name</Td>
      <Td>Plan</Td>
      <Td>Price</Td>
      <Td>Company Price</Td>
      <Td>Action</Td>
    </>
  );
};
